import { useEffect } from "react";

import { useIsSuperAdmin } from "@/api/is-superadmin";
import { useGetOrganisation } from "@/features/organisations/api/get-organisation";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";

export function useRedirectToCV1() {
  const { organisation } = useOrganisation();
  const { data: organisationDetails, isLoading } = useGetOrganisation(
    { id: organisation?.id ?? "" },
    { enabled: !!organisation?.id },
  );
  const { isSuperAdmin, isLoading: isSuperAdminLoading } = useIsSuperAdmin();
  useEffect(() => {
    if (
      !isLoading &&
      !isSuperAdminLoading &&
      !isSuperAdmin &&
      organisationDetails &&
      organisationDetails.isCV1Enabled
    ) {
      const currentPath = window.location.pathname;
      const searchParams = window.location.search;
      window.location.href = `https://app.classview.com${currentPath}${searchParams}`;
    }
  }, [organisationDetails, isLoading, isSuperAdmin, isSuperAdminLoading]);
}
